



























import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

@Component({
  inheritAttrs: false
})
export default class ItemTopicSlidesEditorFormSlide extends Vue {
  number = 0

  @Prop({ type: Number, default: 0 })
  readonly value!: number

  @Prop({ type: Number, default: -Infinity })
  readonly min!: number

  @Prop({ type: Number, default: Infinity })
  readonly max!: number

  @Watch('value', { immediate: true })
  modelValue (value: number) {
    this.modelUpdate(value)
  }

  @Watch('number')
  modelUpdate (number: number) {
    this.number = Math.min(this.max, Math.max(this.min, Math.floor(number) || 0))
    this.$emit('input', this.number)
  }

  get step () {
    return 1
  }

  get inputClass () {
    return this.$attrs.inputClass || 'text-center'
  }

  get inputStyle () {
    return this.$attrs.inputStyle || { fontSize: '1.5em' }
  }

  get attrs () {
    const { type, value, step, ...attrs } = this.$attrs
    return attrs
  }

  get listeners () {
    const { input, ...listeners } = this.$listeners
    return listeners
  }

  decrease () {
    this.number--
  }

  increase () {
    this.number++
  }
}
